import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { MoveProjectToPipelineStageMutation } from '@/gql/graphql';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

const MOVE_PROJECT_TO_PIPELINE_STAGE_MUTATION = graphql(`
  mutation MoveProjectToPipelineStage(
    $input: MoveProjectToPipelineStageInput!
  ) {
    moveProjectToPipelineStage(input: $input) {
      ... on MoveProjectToPipelineStageSuccess {
        project {
          id
        }
      }
      ... on MoveProjectToPipelineStageBlocked {
        project {
          id
        }
        guardResult {
          guard {
            ... on PipelineGuardSimpleCondition {
              type
            }
          }
          isSatisfied
        }
      }
    }
  }
`);

export type UseMoveProjectToPipelineStageOptions<Context = unknown> =
  UseMutationOptions<
    MoveProjectToPipelineStageMutation,
    unknown,
    {
      projectPublicId: string;
      targetPipelineStagePublicId: string;
      currentPipelineStagePublicId: string;
    },
    Context
  >;

const useMoveProjectToPipelineStage = <Context = unknown>(
  options?: UseMoveProjectToPipelineStageOptions<Context>
) => {
  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(MOVE_PROJECT_TO_PIPELINE_STAGE_MUTATION, {
        input: {
          projectId: input.projectPublicId,
          pipelineStageId: input.targetPipelineStagePublicId,
        },
      });
    },
    ...options,
  });
};

export default useMoveProjectToPipelineStage;
